import { NgModule } from '@angular/core';
import { PershingCoreModule } from '@pershing/pershing-core';
import { PershingCommonModule } from '@pershing/pershing-common';
import { RateBoardService } from './services/rateboard.service';
import { RateBoardComponent } from './components/rate-board/rate-board.component';
import { MoneyRatesComponent } from './components/money-rates/money-rates.component';
import { CurrencyRatesComponent } from './components/currency-rates/currency-rates.component';
import { MarginIntRatesComponent } from './components/margin-int-rates/margin-int-rates.component';
import { BankDepProgramComponent } from './components/bank-dep-program/bank-dep-program.component';
import { SecBckFinanceComponent } from './components/sec-bck-finance/sec-bck-finance.component';
import { IntRatesComponent } from './components/int-rates/int-rates.component';
import { CommoditiesComponent } from './components/commodities/commodities.component';
import { MMRatesComponent } from './components/mm-rates/mm-rates.component';
import { StkOptIndicesComponent } from './components/stk-opt-indices/stk-opt-indices.component';
import { CurrencyCalculatorComponent } from './components/currency-calculator/currency-calculator.component';
import { NoCommaPipe } from './pipes/no-comma.pipe';
import { DecimalPipe } from '@angular/common';
import { CurrencyNamePipe } from './pipes/currency-name.pipe';
import { FxRatesComponent } from './components/fx-rates/fx-rates.component';
import { FxRatesLinkComponent } from './components/fx-rates-link/fx-rates-link.component';
import { MMFundsSweepIntComponent } from './components/mm-funds-sweep-int/mm-funds-sweep-int.component';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import { ForeignExchangeComponent } from './components/foreign-exchange/foreign-exchange.component';
import { ModernCurrencyCalculatorComponent } from './components/modern-currency-calculator/modern-currency-calculator.component';
import { ModernRateBoardComponent } from './components/modern-rate-board/modern-rate-board.component';
import { ModernCurrencyRatesComponent } from './components/modern-currency-rates/modern-currency-rates.component';

export const RATEBOARD_COMPONENTS = [
    RateBoardComponent,
    MoneyRatesComponent,
    CurrencyRatesComponent,
    MarginIntRatesComponent,
    BankDepProgramComponent,
    SecBckFinanceComponent,
    IntRatesComponent,
    CommoditiesComponent,
    MMRatesComponent,
    StkOptIndicesComponent,
    CurrencyCalculatorComponent,
    FxRatesComponent,
    FxRatesLinkComponent,
    MMFundsSweepIntComponent,
    ForeignExchangeComponent,
    ModernCurrencyCalculatorComponent,
    ModernRateBoardComponent,
    ModernCurrencyRatesComponent
];
export const RATEBOARD_PIPES = [
    NoCommaPipe,
    CurrencyNamePipe
];
@NgModule({
    imports: [
        PershingCoreModule,
        PershingCommonModule,
        MatTableModule,
        MatExpansionModule,
        MatDividerModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatDialogModule
    ],
    declarations: [...RATEBOARD_COMPONENTS, ...RATEBOARD_PIPES],
    exports: [...RATEBOARD_COMPONENTS],
    entryComponents: [...RATEBOARD_COMPONENTS],
    providers: [RateBoardService, DecimalPipe]
})
export class RateBoardModule { }
